/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';


export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    },
    {
        id: 'master',
        title: 'Masters',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'master.bank',
                title: 'Bank',
                type: 'basic',
                icon: 'heroicons_outline:library',
                link: '/masters/banks'
            }, {
                id: 'master.bankbranch',
                title: 'Bank Branch',
                type: 'basic',
                icon: 'heroicons_outline:library',
                link: '/masters/bankbranches'
            }, {
                id: 'master.zones',
                title: 'Zones',
                type: 'basic',
                icon: 'heroicons_outline:map',
                link: '/masters/zones'
            }
            , {
                id: 'master.areas',
                title: 'Areas',
                type: 'basic',
                icon: 'heroicons_outline:map',
                link: '/masters/areas'
            },
            {
                id: 'master.teams',
                title: 'Teams',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/masters/teams'
            },
            {
                id: 'master.categories',
                title: 'Categories',
                type: 'basic',
                icon: 'heroicons_outline:cube-transparent',
                link: '/masters/categories'
            },
            {
                id: 'master.consultant',
                title: 'Consultants',
                type: 'basic',
                icon: 'heroicons_outline:user-circle',
                link: '/masters/consultants'
            },
            {
                id: 'master.employee',
                title: 'Employees',
                type: 'basic',
                icon: 'heroicons_outline:users',
                link: '/masters/employees'
            },
            {
                id: 'master.optionType',
                title: 'Option Types',
                type: 'basic',
                icon: 'heroicons_outline:view-grid',
                link: '/masters/optiontypes'
            }
            ,
            {
                id: 'master.option',
                title: 'Options',
                type: 'basic',
                icon: 'heroicons_outline:desktop-computer',
                link: '/masters/options'
            },
            {
                id: 'master.remark',
                title: 'Remarks',
                type: 'basic',
                icon: 'heroicons_outline:annotation',
                link: '/masters/remarks'
            },
            {
                id: 'master.bankAccountDetail',
                title: 'Bank Accounts',
                type: 'basic',
                icon: 'heroicons_outline:identification',
                link: '/masters/bankaccountdetails'
            },
            {
                id: 'master.loandepartments',
                title: 'Loan Departments',
                type: 'basic',
                icon: 'heroicons_outline:identification',
                link: '/masters/loandepartments'
            },
            {
                id: 'master.templates',
                title: 'Templates',
                type: 'basic',
                icon: 'heroicons_outline:identification',
                link: '/masters/templates'
            },
            {
                id: 'master.cities',
                title: 'City',
                type: 'basic',
                icon: 'heroicons_outline:identification',
                link: '/masters/cities'
            },
            {
                id: 'master.roles',
                title: 'Roles',
                type: 'basic',
                icon: 'heroicons_outline:identification',
                link: '/masters/roles'
            },
        ]
    }, {
        id: 'transaction',
        title: 'Transactions',
        type: 'group',
        icon: 'heroicons_outline:collection',
        children: [
            {
                id: 'transaction.inward',
                title: 'Inwards',
                type: 'basic',
                icon: 'heroicons_outline:inbox-in',
                link: '/transactions/inwards'
            },
            {
                id: 'transaction.invoice',
                title: 'Invoices',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-check',
                link: '/transactions/invoices'
            },
            {
                id: 'transaction.payment',
                title: 'Payments',
                type: 'basic',
                icon: 'heroicons_outline:currency-rupee',
                link: '/transactions/payments'
            },
            {
                id: 'master.expenses',
                title: 'Expenses',
                type: 'basic',
                icon: 'heroicons_outline:currency-rupee',
                link: '/masters/expenses'
            }
        ]
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'group',
        icon: 'heroicons_outline:document-report',
        children: [
            {
                id: 'reports.searchValue',
                title: 'Search Value',
                type: 'basic',
                icon: 'heroicons_outline:document-search',
                link: '/reports/searchValues',
                target: '_blank'
            },
            {
                id: 'reports.reportRegister',
                title: 'Report Register',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/reports/reportRegister'
            },
            {
                id: 'reports.bankWiseOutwardSummary',
                title: 'Bank Wise Outward Summary',
                type: 'basic',
                icon: 'heroicons_outline:view-grid',
                link: '/reports/bankWiseOutwardSummary'
            },
            {
                id: 'reports.reportstatushistory',
                title: 'Report Status History',
                type: 'basic',
                icon: 'heroicons_outline:paper-airplane',
                link: '/reports/reportstatushistory'
            },
            {
                id: 'reports.previousValuations',
                title: 'Previous Valuations',
                type: 'basic',
                icon: 'heroicons_outline:location-marker',
                link: '/reports/previousValuations'
            },
        ]
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    },
    {
        id: 'master',
        title: 'Masters',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: []
    }, {
        id: 'transaction',
        title: 'Transactions',
        type: 'group',
        icon: 'heroicons_outline:collection',
        children: []
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'group',
        icon: 'heroicons_outline:document-report',
        children: []
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    },
    {
        id: 'master',
        title: 'Masters',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: []
    }, {
        id: 'transaction',
        title: 'Transactions',
        type: 'group',
        icon: 'heroicons_outline:collection',
        children: []
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'group',
        icon: 'heroicons_outline:document-report',
        children: []
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    },
    {
        id: 'master',
        title: 'Masters',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: []
    }, {
        id: 'transaction',
        title: 'Transactions',
        type: 'group',
        icon: 'heroicons_outline:collection',
        children: []
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'group',
        icon: 'heroicons_outline:document-report',
        children: []
    }
];
